export { default as courseFragment } from './course-fragment';
export { default as createOneCourseMutation } from './create-one-course-mutation';
export { default as findByAliasCourseQuery } from './find-by-alias-course-query';
export { default as findByIdCourseQuery } from './find-by-id-course-query';
export { default as findCourseInfoByIdsQuery } from './find-course-info-by-ids-query';
export { default as findManyCourseQuery } from './find-many-course-query';
export { default as findOneCourseQuery } from './find-one-course-query';
export { default as removeByIdCourseMutation } from './remove-by-id-course-mutation';
export { default as updateByIdCourseMutation } from './update-by-id-course-mutation';
